import { defaultTranslationKeysWithNamespaces as spaDefaultTranslationsKeysWithNamespaces } from '@ori-appshell/app-loaders';
import { defaultLayoutTranslationKeysWithNamespaces } from '@ori-appshell/layouts';
/**
 * Collection of default translations that has been migrated to spa project in poeditor
 */ export const defaultNamespacedTranslations = {
    ...defaultLayoutTranslationKeysWithNamespaces,
    ...spaDefaultTranslationsKeysWithNamespaces
};
